import { Button, Uploader } from 'rsuite';
import type { FileType } from 'rsuite/Uploader';

interface ImagePickerProps {
    value?: FileType;
    label?: string;
    disabled?: boolean;
    onFileSelect: (file: FileType) => void;
}

export const ImagePicker: React.FC<ImagePickerProps> = ({
    label = 'Click me',
    value,
    disabled = false,
    onFileSelect,
}) => {
    return (
        <div>
            <Uploader
                multiple={false}
                listType="picture-text"
                autoUpload={false}
                accept="image/*"
                action="#"
                fileList={value ? [value] : []}
                onChange={(fileList: FileType[]) => {
                    if (fileList.length > 0) {
                        onFileSelect(fileList[0]);
                    }
                }}
                disabled={disabled}
            >
                <Button appearance="primary">{label}</Button>
            </Uploader>
        </div>
    );
};
